import { render, staticRenderFns } from "./bestSelling.vue?vue&type=template&id=339df015&scoped=true&"
import script from "./bestSelling.vue?vue&type=script&lang=js&"
export * from "./bestSelling.vue?vue&type=script&lang=js&"
import style0 from "./bestSelling.vue?vue&type=style&index=0&id=339df015&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339df015",
  null
  
)

export default component.exports